import axios from "axios";
import { configUrl } from "config.js";

const getAllPrograms = async (Page, PageSize, Status) => {
    let status = Status ?? "New";
    let pageSize = PageSize ?? 10;
    let page = Page ?? 1;

    let Response = await axios.get(
        `${configUrl.AssessmentServer}/api/Program/GetProgramsList`,
    );

    let ProgramsData = Response?.data;
    return ProgramsData;
};
export default {
    getAllPrograms: getAllPrograms,
};
